import {useBoardDataContext} from './provider/contexts'
import type {BoardData} from './types'

/**
 * The same `data` object that was passed to `BoardProvider`, so a nested component can
 * reach a column, a row or a cell's items without prop-drilling. It returns exactly
 * what went in and nothing else.
 */
export function useBoardData<TItem>(): BoardData<TItem> {
  return useBoardDataContext().data as BoardData<TItem>
}
